import './index.less'
import { VideoPlayer, } from '@utils/index'

$(function () {
  document.querySelectorAll('.pdp-two-text-img').forEach(item => {
    if (item.dataset.playVideoByOrder === 'true') {
      // 初始化视频播放器
      const videoPlayer = new VideoPlayer({
        container: item,
        videoSelector: 'jky-video',
        onTrack: null, // 数据埋码
      })

      // 初始化视频点击事件并观察视口
      videoPlayer?.init()?.observe()
    }
  })
})